export const mockTestimonials = [
  {
    name: "Maria Rodriguez",
    location: "Orlando, FL",
    text: "The care my mother receives is exceptional. Professional, compassionate, and always reliable. We couldn't ask for better support."
  },
  {
    name: "James Patterson",
    location: "Kissimmee, FL",
    text: "Graceful Hands has given our family peace of mind. My father looks forward to every visit and the quality of care is outstanding."
  },
  {
    name: "Linda Chen",
    location: "Saint Cloud, FL",
    text: "Truly caring and attentive service. They treat my grandmother like family and go above and beyond every single day."
  }
];